import axios from 'axios';
import { AlarmedBoxesResponse, AlarmType, BoxStatusCardData, SensorFilters, TimelineFilters, TimelineResponse } from '../types/sensors';

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchAlarmedBoxes(filters: SensorFilters): Promise<AlarmedBoxesResponse> {
  const params: Record<string, any> = {
    take: filters.page - 1,
    skip: filters.items_per_page,
    sort: filters.sort,
  };
  if (filters.cmb_number) params.cmb_number = filters.cmb_number;
  if (filters.alarm_types?.length) params.alarm_types = filters.alarm_types;
  if (filters.company_id) params.company_id = filters.company_id;
  if (filters.project_id) params.project_id = filters.project_id;

  const { data } = await axios.get<AlarmedBoxesResponse>(`${API_URL}/sensors/alarmed-boxes`, { params });
  return data;
}

export async function fetchBoxTimeline(box_id: number, filters: TimelineFilters): Promise<TimelineResponse> {
  const { data } = await axios.get<TimelineResponse>(`${API_URL}/sensors/box/${box_id}/timeline`, {
    params: {
      take: filters.page - 1,
      skip: filters.items_per_page,
      event_types: filters.event_types,
      since: filters.since,
    },
  });
  return data;
}

export async function fetchBoxStatus(box_id: number): Promise<BoxStatusCardData | null> {
  const { data } = await axios.get<{ data: BoxStatusCardData | null }>(`${API_URL}/sensors/box/${box_id}/status`);
  return data.data ?? null;
}

// Clears all active alarms for the given box. The backend endpoint
// `POST /log-box/nastek/clear-alarm/:box_id` operates on the whole box and
// does not currently accept a per-type body, so `alarm_types` is accepted
// for future-proofing (and intent-documentation) but is not sent to the
// backend right now. When the API gains per-type clearing, switch this
// helper to send `{ type_ids: [...] }` and stop relying on the box-wide
// behavior.
export async function clearBoxAlarmsBatch(
  box_id: number,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _alarm_types: AlarmType[],
): Promise<void> {
  await axios.post(`${API_URL}/log-box/nastek/clear-alarm/${box_id}`);
}
